<template>
  <div
    class="multiFilter-component"
    :style="model !== 'filter' ? styleObject : ''"
    :class="options.indrawer ? 'has-drawer' : ''"
    ref="multiFilter"
  >
    <el-scrollbar style="height: 100%">
      <div class="filter-box" v-if="!model && moreFilter === true">
        <div
          class="filter-layer1 verticallyTop"
          :class="[arrangeType === 'vertical' ? 'vertical-layer' : '']"
          v-for="(item1, index1) in selectOptionsNew"
          :key="index1"
          :style="styleGroup"
          :id="ids.rect_id + '_' + index1"
        >
          <div class="layer1-name mr12" :style="styleTitle()">
            {{ titleContentHasLimit && item1.label ? item1.label.substr(0, options.titleTextLimitCount) : item1.label }}
          </div>
          <div class="layer2-box tl" :style="getSizeStyle">
            <div
              class="filter-layer2 inlineMiddle pointer"
              v-for="(item2, index2) in item1.children"
              @click="activeFunc(item2.active, index2, 1, index1)"
              :class="{ 'active-type': item2.active }"
              :style="styleList"
              :key="index2"
            >
              {{ contentHasLimit && item2.label ? item2.label.substr(0, options.textLimitWords) : item2.label }}
            </div>
          </div>
          <!-- 展开收起按钮 -->
          <toggle-button
              v-if="showToggleButton"
              :id="'btn_' + ids.rect_id + '_' + index1"
              :myid="myid"
              :options="options"
              buttonType="toggleButton"
              @handleClick="toggleData(true, index1)"
              ></toggle-button>
        </div>
      </div>
      <div class="filter-box" v-if="!model && moreFilter === false">
        <div class="filter-layer1 tl" :style="{...styleGroup, ...getSizeStyle}">
          <div
            class="filter-layer2 inlineMiddle pointer"
            v-for="(item1, index1) in selectOptionsNew"
            @click="activeFunc(item1.active, index1, 2)"
            :class="{ 'active-type': item1.active }"
            :style="styleList"
            :key="index1"
          >
            {{ contentHasLimit ? item1.label.substr(0, options.textLimitWords) : item1.label }}
          </div>
        </div>
      </div>
      <div class="filter-box" v-if="model === 'tree'">
        <div
          class="filter-layer1 verticallyTop"
          :key="index"
          :style="styleGroup"
          v-for="(item, index) in selectedOptions"
          :id="ids.rect_id + '_' + index"
        >
          <div class="layer1-name mr12" :style="styleTitle()">
            {{ (showCategoryNames && categoryNames[index]) || (index === 0 ? "分类名称" : "子分类") }}
          </div>
          <div class="layer2-box tl" :style="getSizeStyle">
              <div
                v-for="(subItem, subIndex) in displayItems[index]"
                :key="subIndex"
                class="filter-layer2 inlineMiddle pointer"
                @click="handleItemClick(subItem, true)"
                :class="{ 'active-type': selectedOptions[index] === subItem.id }"
                :style="styleList"
              >
                {{ contentHasLimit ? subItem.label.substr(0, options.textLimitWords) : subItem.label }}
              </div>
          </div>
          <!-- 展开收起按钮 -->
          <toggle-button
              v-if="showToggleButton"
              :id="'btn_' + ids.rect_id + '_' + index"
              :myid="myid"
              :options="options"
              buttonType="toggleButton"
              @handleClick="toggleData(true, index)"
          ></toggle-button>
        </div>
      </div>
      <div class="filter-box" v-if="model === 'filter'" ref="filterBox">
        <div class="filter-layer" ref="filterLayer" :style="{...styleObject, ...filterStyle}">
          <div
            :key="index1"
            v-for="(item1, index1) in selectOptionsNew"
            class="filter-item"
            :class="{ 'active-type': item1.active }"
            :style="styleTitle(item1.active)"
            @click="filterFunc(item1.active, index1, 3)"
          >
            <span :style="getFontStyle(item1)" v-if="titleIconPosition(item1.active) === 'right'">{{
              getTitleContent(item1)
            }}</span>
            <div class="inline">
              <cxIcon
                class="icon"
                v-if="titleIconType(item1.active) === 'icon' && options.titleTitleIconShow !== false"
                :options="options"
                :iconStyle="titleIconStyle(item1.active)"
                :iconSrcName="item1.active ? 'titleActiveIconSrc' : 'titleIconSrc'"
              />
              <img
                class="icon"
                v-else-if="
                  titleIconType(item1.active) === 'img' &&
                  options.titleTitleIconShow !== false &&
                  (item1.active ? options.titleActiveIconSrc : options.titleIconSrc)
                "
                :src="item1.active ? options.titleActiveIconSrc : options.titleIconSrc"
                :style="titleIconImgStyle(item1.active)"
              />
            </div>
            <span :style="getFontStyle(item1)" v-if="titleIconPosition(item1.active) === 'left'">{{
              getTitleContent(item1)
            }}</span>
          </div>
        </div>
        <div class="filter-query" :style="selectBoxStyle" v-if="labelShow">
          <div class="filter-item" :style="selectStyle" v-for="(item, index) in selectList" :key="index" >
            <span v-if="labelIconPosition === 'right' || labelIconPosition === 'bottom'">{{ options.labelContentHasLimit === true ? item.label.substr(0, options.labelTextLimitWords) : item.label }}</span>
            <div class="pointer" :class="labelIconPosition === 'left' || labelIconPosition === 'right' ? 'inline' : ''" @click="delClick(item, index)">
              <cxIcon
                class="icon"
                v-if="options.labelIconType !== 'img'"
                :options="options"
                :iconStyle="labelIconStyle"
                iconSrcName="labelIconSrc"
              />
              <img
                class="icon"
                v-else-if="options.labelIconType === 'img' && options.labelIconColor"
                :src="options.labelIconColor"
                :style="labelIconImgStyle"
              />
            </div>
            <span v-if="labelIconPosition === 'left' || labelIconPosition === 'top'">{{ options.labelContentHasLimit === true ? item.label.substr(0, options.labelTextLimitWords) : item.label }}</span>
          </div>
        </div>
        <teleport-comp to="body" class="filterRect" v-show="showDialog">
          <div class="option-layer" :style="dialogBgStyle" @click.stop="confirmData()">
            <div class="sub-box" :style="subFilterStyle">
              <div class="menu-div" :style="subMenuBoxStyle">
                <ul class="menu-box">
                  <li
                    class="sub-menu"
                    :style="styleList"
                    v-for="(subItem, index) in subMenuList"
                    :key="index"
                    :class="{ 'active-type': subItem.active }"
                    @click.stop="filterFunc(subItem.active, index, 4, activeIndex)"
                  >
                    <span v-if="subMenuIconPosition(subItem.active) === 'right' || subMenuIconPosition(subItem.active) === 'bottom'">{{ contentHasLimit ? subItem.label.substr(0, options.textLimitWords) : subItem.label }}</span>
                    <div :class="subMenuIconPosition(subItem.active) === 'left' || subMenuIconPosition(subItem.active) === 'right' ? 'inline' : ''" v-if="getShowIcon(subItem.active)">
                      <cxIcon
                        class="icon"
                        v-if="subMenuIconType(subItem.active) === 'icon'"
                        :options="options"
                        :iconStyle="subMenuIconStyle(subItem.active)"
                        :iconSrcName="subItem.active ? 'activeIconSrc' : 'defaultIconSrc'"
                      />
                      <img
                        class="icon"
                        v-else-if="
                          subMenuIconType(subItem.active) === 'img' &&
                          (subItem.active ? options.activeIconSrc : options.defaultIconSrc)
                        "
                        :src="subItem.active ? options.activeIconSrc : options.defaultIconSrc"
                        :style="subMenuIconImgStyle(subItem.active)"
                      />
                    </div>
                    <span v-if="subMenuIconPosition(subItem.active) === 'left' || subMenuIconPosition(subItem.active) === 'top'">{{ contentHasLimit ? subItem.label.substr(0, options.textLimitWords) : subItem.label }}</span>
                  </li>
                </ul>
              </div>
              <div class="filter-footer" v-if="filterType == '2'" :style="footerStyle">
                <dialog-button v-if="openResetButton" :myid="myid" :options="options" buttonType="resetButton" @handleClick="resetData()"></dialog-button >
                <dialog-button :myid="myid" :options="options" buttonType="sureButton" @handleClick="confirmData()"></dialog-button >
                <!-- <el-button v-if="openResetButton" @click.stop="resetData()">重置</el-button>
                <el-button type="primary" @click="confirmData()">确 定</el-button> -->
              </div>
            </div>
          </div>
        </teleport-comp>
      </div>
      <div class="demo-drawer__footer" v-if="options.indrawer">
        <el-button @click="closeDrawer()">取 消</el-button>
        <el-button type="primary" @click="confirmDrawer()">确 定</el-button>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { isSsrPage } from "utils/index"
import eventMixin from "utils/event/eventMixin.js"
import subPageEventMixin from "utils/event/subPageEventMixin.js"
import plugins from "./plugin"
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
import teleportComp from "components/teleportComp.js"
import dialogButton from "./button.vue"
import toggleButton from "./toggleButton.vue"
import { getAttrById, getQueryParam } from "../../../utils"
import $ from "jquery"

export default {
  mixins: [eventMixin, plugins, subPageEventMixin],
  name: "cxMultiFilter",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  components: { teleportComp, dialogButton, toggleButton },
  data() {
    return {
      selectOptionsNew: [],
      filterItems: [], // 树展开后的全量选项数据
      displayItems: [], // 对应于界面的展示数据
      selectedOptions: [], // 已选中的数据
      selectedFilter: "",
      subMenuList: [],
      showDialog: false,
      activeIndex: -1, // 样式四选中一级分类索引
      selectList: [],
      countNumber: 0,
    }
  },
  watch: {
    "options.selectOptions"(n, o) {
      this.selectOptionsNew = n
    },
    "options.filterOptions"(n, o) {
      this.model === "tree" && this.initMultiFilterTree()
    },
    // 是否显示全部改变后, 如果为真，则需要为有选择项的部分添加all
    "options.showAll"(val) {
      this.initDisplayItems(this.selectedOptions)
    },
    "options.model"(val) {
      if (val === "tree") {
        this.initMultiFilterTree()
      }
    },
    selectOptionsNew(val) {
      if (this.model === "filter") {
        // window.localStorage.setItem("multiSelectOptions", JSON.stringify(val))
        // 将展开项传给右侧
        // this.$eventBus.$emit('changeActiveMenu', {
        //   rect_id: this.ids.rect_id,
        //   publicId: val[this.activeIndex === -1 ? 0 : this.activeIndex].publicId,
        //   isActive: this.showDialog
        // })
        // 已选标签
        this.getSelectList(val)
      }
      this.toggleDataFunc1(val)
    },
    selectedOptions(val) {
      this.toggleDataFunc1(val)
    },
    "options.buttonShow"(n, o) {
      if(n || n === false){
        let val = []
        if(!this.model && this.moreFilter === true){
          val = this.selectOptionsNew
        }else if(this.model === "tree"){
          val = this.selectedOptions
        }
        if(n === false){ //清除按钮
          this.toggleDataFunc1(val, true)
        }else{
          this.toggleDataFunc1(val)
        }
      }
    },
  },
  computed: {
    arrangeType() {
      return this.options.arrangeType
    },
    activeValue: {
      get() {
        return this.options.activeValue
      },
      set(val) {
        this.$store.dispatch(this.request_prefix + "/changeOptions", {
          ...this.myid,
          option_name: "activeValue",
          option_val: val
        })
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    showAll() {
      return this.options.showAll
    },
    showCategoryNames() {
      return this.options.showCategoryNames
    },
    categoryNames() {
      return this.options.categoryNames || []
    },
    themeColor() {
      return isSsrPage() ? this.$store.state.page.themeColor : this.$store.state[this.request_prefix].page.themeColor
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor ? this.themeColor : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    styleObject() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      let thisStyle = {
        color: this.$parseColor(this.options.color),
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-style": this.options.borderStyle,
        // "border-color": this.options.borderIsThemeColor
        //   ? this.themeColor
        //   : this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        "border-width": this.options.filterShowBorder !== false ? borderW : 0,
        "box-shadow": this.boxShadowStyle,
        opacity: this.options.opacity,
        padding: this.model === "filter" ? "" : this.getPaddingStyle,
        // width: this.options.filterWidthFull !== false ? "100%" : this.options.filterWidth + "px",
        // height: this.options.filterHeightAuto
        //   ? "auto"
        //   : this.options.filterHeightFull !== false
        //   ? "100%"
        //   : this.options.filterHeight + "px"
      }
      return {
        ...this.bgStyle,
        ...thisStyle
      }
    },
    styleGroup() {
      return {
        "margin-bottom": this.options.groupMargin + "px",
        "--layer2MarginBottom": "-" + this.options.lineMargin + "px"
      }
    },
    titleBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.titleBoxShadowH)) {
        this.options.titleBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.titleBoxShadowH[index]}px ${_this.options.titleBoxShadowV[index]}px ${_this.options.titleBoxShadowBlur[index]}px ${_this.options.titleBoxShadowSpread[index]}px ${this.$parseColor(_this.options.titleBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.titleBoxShadowH}px ${this.options.titleBoxShadowV}px ${this.options.titleBoxShadowBlur}px ${this.options.titleBoxShadowSpread}px ${this.$parseColor(this.options.titleBoxShadowColor)}`
      }
      return tmpStyle
    },
    getSizeStyle() {
      if (this.subMenuWidthFull) {
        return {
          display: "flex",
          flex: 1,
        }
      } else return {}
    },
    styleList() {
      let borderW = "",
        hoverBorderW = "",
        activeBorderW = ""
      if (Array.isArray(this.options.defaultBorderWidth)) {
        this.options.defaultBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.defaultBorderWidth}px`
      }
      //悬浮
      if (Array.isArray(this.options.hoverBorderWidth)) {
        this.options.hoverBorderWidth.forEach(item => [(hoverBorderW += ` ${item}px`)])
      } else {
        hoverBorderW += ` ${this.options.hoverBorderWidth}px`
      }
      // 选中
      if (Array.isArray(this.options.activeBorderWidth)) {
        this.options.activeBorderWidth.forEach(item => [(activeBorderW += ` ${item}px`)])
      } else {
        activeBorderW += ` ${this.options.activeBorderWidth}px`
      }
      let widthFull = this.subMenuWidthFull ? {
        flex: 1
      } : {}
      let thisStyle = {
        width: !this.subMenuWidthAuto && !this.subMenuWidthFull ? this.options.subMenuWidth + "px" : "",
        ...widthFull,
        height: !this.subMenuHeightAuto ? this.options.subMenuHeight + "px" : "",
        "margin-bottom": this.model !== "filter" ? this.options.lineMargin + "px" : "",
        "margin-right": this.model !== "filter" ? this.options.columnMargin + "px" : "",

        "font-Family": this.options.fontFamily,
        "font-size": this.options.fontSize + "px",
        "font-weight": this.options.fontWeight,
        "line-height":
          this.options.lineHeightType === "%" ? this.options.lineHeight / 100 : this.options.lineHeight + "px",
        "font-style": this.options.fontStyle,
        "letter-spacing": this.options.letterSpacing + "px",
        "text-decoration": this.options.textDecoration,
        "text-decoration-color": this.$parseColor(this.options.color),
        // color: this.options.textIsThemeColor ? this.themeColor : this.options.color.color,
        color: this.$parseColor(this.options.color, {
          isThemeColor: this.options.textIsThemeColor
        }),
        "border-top-left-radius": this.options.defaultBorderTopLeftRadius + "px",
        "border-top-right-radius": this.options.defaultBorderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.defaultBorderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.defaultBorderBottomLeftRadius + "px",
        "border-style": this.options.defaultBorderStyle,
        // "border-color": this.options.defaultBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.defaultBorderColor.color
        //   ? this.options.defaultBorderColor.color
        //   : this.options.defaultBorderColor,
        "border-color": this.$parseColor(this.options.defaultBorderColor, {
          isThemeColor: this.options.defaultBorderIsThemeColor
        }),
        "border-width": this.options.defaultShowBorder !== false ? borderW : 0,
        "box-shadow": this.defaultBoxShadowStyle,
        opacity: this.options.hasOwnProperty("defaultOpacity") ? this.options.defaultOpacity / 100 : 1,
        "text-align": this.options.textAlign,
        "writing-mode": this.options.writingMode,

        "--hoverFontFamily": this.options.hoverFontFamily,
        "--hoverFontSize": this.options.hoverFontSize + "px",
        "--hoverFontWeight": this.options.hoverFontWeight,
        "--hoverLineHeight":
          this.options.hoverLineHeightType === "%"
            ? this.options.hoverLineHeight / 100
            : this.options.hoverLineHeight + "px",
        "--hoverFontStyle": this.options.hoverFontStyle,
        "--hoverLetterSpacing": this.options.hoverLetterSpacing + "px",
        "--hoverTextDecoration": this.options.hoverTextDecoration,
        "--hoverTextDecorationColor": this.$parseColor(this.options.hoverColor),
        // "--hoverColor": this.options.hoverColorIsThemeColor ? this.themeColor : this.options.hoverColor.color || this.options.hoverColor,
        "--hoverColor": this.$parseColor(this.options.hoverColor, {
          isThemeColor: this.options.hoverColorIsThemeColor
        }),
        "--hoverBorderTopLeftRadius": this.options.hoverBorderTopLeftRadius + "px",
        "--hoverBorderTopRightRadius": this.options.hoverBorderTopRightRadius + "px",
        "--hoverBorderBottomRightRadius": this.options.hoverBorderBottomRightRadius + "px",
        "--hoverBorderBottomLeftRadius": this.options.hoverBorderBottomLeftRadius + "px",
        "--hoverBorderStyle": this.options.hoverBorderStyle,
        // "--hoverBorderColor": this.options.hoverBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.hoverBorderColor.color,
        "--hoverBorderColor": this.$parseColor(this.options.hoverBorderColor, {
          isThemeColor: this.options.hoverBorderIsThemeColor
        }),
        "--hoverBorderWidth": this.options.hoverShowBorder !== false ? hoverBorderW : 0,
        "--hoverBoxShadow": this.hoverBoxShadowStyle,
        "--hoverBackgroundColor": this.$parseColor(this.hoverBgStyle.backgroundColor),
        "--hoverBackgroundImage": this.hoverBgStyle.backgroundImage,
        "--hoverBackgroundSize": this.hoverBgStyle.backgroundSize,
        "--hoverBackgroundPosition": this.hoverBgStyle.backgroundPosition,
        "--hoverBackgroundRepeat": this.hoverBgStyle.backgroundRepeat,

        "--activeFontFamily": this.options.activeFontFamily,
        "--activeFontSize": this.options.activeFontSize + "px",
        "--activeFontWeight": this.options.activeFontWeight,
        "--activeLineHeight":
          this.options.activeLineHeightType === "%"
            ? this.options.activeLineHeight / 100
            : this.options.activeLineHeight + "px",
        "--activeFontStyle": this.options.activeFontStyle,
        "--activeLetterSpacing": this.options.activeLetterSpacing + "px",
        "--activeTextDecoration": this.options.activeTextDecoration,
        "--activeTextDecorationColor": this.$parseColor(this.options.activeColor),
        // "--activeColor": this.options.activeColorIsThemeColor ? this.themeColor : this.options.activeColor.color || this.options.activeColor,
        "--activeColor": this.$parseColor(this.options.activeColor, {
          isThemeColor: this.options.activeColorIsThemeColor
        }),
        "--activeBorderTopLeftRadius": this.options.activeBorderTopLeftRadius + "px",
        "--activeBorderTopRightRadius": this.options.activeBorderTopRightRadius + "px",
        "--activeBorderBottomRightRadius": this.options.activeBorderBottomRightRadius + "px",
        "--activeBorderBottomLeftRadius": this.options.activeBorderBottomLeftRadius + "px",
        "--activeBorderStyle": this.options.activeBorderStyle,
        // "--activeBorderColor": this.options.activeBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.activeBorderColor.color,
        "--activeBorderColor": this.$parseColor(this.options.activeBorderColor, {
          isThemeColor: this.options.activeBorderIsThemeColor
        }),
        "--activeBorderWidth": this.options.activeShowBorder !== false ? activeBorderW : 0,
        "--activeBoxShadow": this.activeBoxShadowStyle,
        // "--activeBackgroundColor": this.activeBgStyle.backgroundColor,
        "--activeBackgroundColor": this.$parseColor(this.activeBgStyle.backgroundColor),
        "--activeBackgroundImage": this.activeBgStyle.backgroundImage,
        "--activeBackgroundSize": this.activeBgStyle.backgroundSize,
        "--activeBackgroundPosition": this.activeBgStyle.backgroundPosition,
        "--activeBackgroundRepeat": this.activeBgStyle.backgroundRepeat,

        padding: this.getDefaultPaddingStyle
      }
      return {
        ...this.defaultBgStyle,
        ...thisStyle
      }
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (!this.options.paddingTypeFlag || this.options.paddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    defaultBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.defaultBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("titleBgColorIsThemeColor")
              ? this.options.defaultBgColorIsThemeColor
              : false,
            color: this.options.defaultBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor ? this.themeColor : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    hoverBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.hoverBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("titleBgColorIsThemeColor")
              ? this.options.hoverBgColorIsThemeColor
              : false,
            color: this.options.hoverBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor ? this.themeColor : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    activeBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.activeBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("titleBgColorIsThemeColor")
              ? this.options.activeBgColorIsThemeColor
              : false,
            color: this.options.activeBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor ? this.themeColor : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    defaultBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.defaultBoxShadowH)) {
        this.options.defaultBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.defaultBoxShadowH[index]}px ${_this.options.defaultBoxShadowV[index]}px ${_this.options.defaultBoxShadowBlur[index]}px ${_this.options.defaultBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.defaultBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.defaultBoxShadowH}px ${this.options.defaultBoxShadowV}px ${this.options.defaultBoxShadowBlur}px ${this.options.defaultBoxShadowSpread}px ${this.$parseColor(this.options.defaultBoxShadowColor)}`
      }
      return tmpStyle
    },
    hoverBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.hoverBoxShadowH)) {
        this.options.hoverBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.hoverBoxShadowH[index]}px ${_this.options.hoverBoxShadowV[index]}px ${_this.options.hoverBoxShadowBlur[index]}px ${_this.options.hoverBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.hoverBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.hoverBoxShadowH}px ${this.options.hoverBoxShadowV}px ${this.options.hoverBoxShadowBlur}px ${this.options.hoverBoxShadowSpread}px ${_this.$parseColor(this.options.hoverBoxShadowColor)}`
      }
      return tmpStyle
    },
    activeBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.activeBoxShadowH)) {
        this.options.activeBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.activeBoxShadowH[index]}px ${_this.options.activeBoxShadowV[index]}px ${_this.options.activeBoxShadowBlur[index]}px ${_this.options.activeBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.activeBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.activeBoxShadowH}px ${this.options.activeBoxShadowV}px ${this.options.activeBoxShadowBlur}px ${this.options.activeBoxShadowSpread}px ${_this.$parseColor(this.options.activeBoxShadowColor)}`
      }
      return tmpStyle
    },
    getTitlePaddingStyle() {
      let padding = `${this.options.titlePadding}px`
      if (!this.options.titlePaddingTypeFlag || this.options.titlePaddingTypeFlag === 2) {
        padding = ` ${this.options.titlePaddingTop}px  ${this.options.titlePaddingRight}px  ${this.options.titlePaddingBottom}px  ${this.options.titlePaddingLeft}px`
      }
      return padding
    },
    getDefaultPaddingStyle() {
      let padding = `${this.options.defaultPadding}px`
      if (!this.options.defaultPaddingTypeFlag || this.options.defaultPaddingTypeFlag === 2) {
        padding = ` ${this.options.defaultPaddingTop}px  ${this.options.defaultPaddingRight}px  ${this.options.defaultPaddingBottom}px  ${this.options.defaultPaddingLeft}px`
      }
      return padding
    },
    moreFilter() {
      return this.options ? this.options.moreFilter : true
    },
    model() {
      return this.options.model
    },
    drawerShow() {
      let show1 = undefined
      if (this.options.indrawer) {
        let relativeBtn = this.$store.state[this.request_prefix].page.children[0].children.find(item =>
          item.options.pluginName?.includes("appMultiFilterDrawerPlugin")
        )
        let correlationLayoutId = relativeBtn.options.correlationLayoutId
        let parentPath = correlationLayoutId.split("_")[0]
        let layoutItem = this.$store.state.appStage.page.pageLayoutList.find(item => item.id == parentPath)
        show1 = layoutItem.layout.rows[0].options.drawerParams
      }
      return show1
    },
    titleBgStyle() {
      return function (isActive) {
        let containerBg = {
          backgroundImage: ""
        }
        let curBackground = isActive ? this.options.titleActiveBackground : this.options.titleBackground
        if (
          !curBackground ||
          !Array.isArray(curBackground) ||
          (Array.isArray(curBackground) && curBackground.length === 0)
        ) {
          curBackground = [
            {
              type: "color",
              label: "颜色",
              isThemeColor: isActive
                ? this.options.titleActiveBgColorIsThemeColor
                : this.options.titleBgColorIsThemeColor,
              color: isActive ? this.options.titleActiveBgColor : this.options.titleBgColor
            }
          ]
        }
        curBackground.forEach(bg => {
          switch (bg.type) {
            case "img":
              let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
              containerBg.backgroundSize = containerBg.backgroundSize
                ? `${containerBg.backgroundSize},${bg.clipSize}`
                : `${bg.clipSize}`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},${bg.alignType}`
                : `${bg.alignType}`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},${bg.repeatType}`
                : `${bg.repeatType}`
              break
            case "color":
              // containerBg.backgroundColor = bg.isThemeColor ? this.themeColor : bg.color
              containerBg.backgroundColor = this.$parseColor(bg)
              break
            case "linearGradient":
              let tmp = []
              if (bg.data.stops.length > 0) {
                bg.data.stops.forEach(item => {
                  tmp.push(item[0] + " " + item[1] * 100 + "%")
                })
                let dot = containerBg.backgroundImage.length > 0 ? "," : ""
                // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
                containerBg.backgroundImage += dot + this.$parseColor(bg)
                containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
                containerBg.backgroundPosition = containerBg.backgroundPosition
                  ? `${containerBg.backgroundPosition},center`
                  : `center`
                containerBg.backgroundRepeat = containerBg.backgroundRepeat
                  ? `${containerBg.backgroundRepeat},no-repeat`
                  : `no-repeat`
              }
              break
            case "radialGradient":
              let radialTmp = []
              if (bg.data.stops.length > 0) {
                bg.data.stops.forEach(item => {
                  radialTmp.push(item[0] + " " + item[1] * 100 + "%")
                })
                let dot = containerBg.backgroundImage.length > 0 ? "," : ""
                // containerBg.backgroundImage +=
                //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
                containerBg.backgroundImage += dot + this.$parseColor(bg)
                containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
                containerBg.backgroundPosition = containerBg.backgroundPosition
                  ? `${containerBg.backgroundPosition},center`
                  : `center`
                containerBg.backgroundRepeat = containerBg.backgroundRepeat
                  ? `${containerBg.backgroundRepeat},no-repeat`
                  : `no-repeat`
              }
              break
            default:
          }
        })
        return containerBg
      }
    },
    titleTextLimit() {
      return this.options.hasOwnProperty("titleTextLimit") ? this.options.titleTextLimit : true
    },
    titleContentHasLimit() {
      return this.titleTextLimit && this.options.titleContentHasLimitRadio === "字数"
    },
    contentHasLimit() {
      return this.options.contentHasLimit && this.options.contentHasLimitRadio === "字数"
    },
    styleTitle() {
      return function (isActive) {
        let borderW = ""
        const borderWidth = isActive ? this.options.titleActiveBorderWidth : this.options.titleBorderWidth
        if (Array.isArray(borderWidth)) {
          borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        } else {
          borderW += ` ${borderWidth}px`
        }
        const showBorder = isActive ? this.options.titleActiveBorderShow : this.options.titleBorderShow
        let widthFull = this.options.titleWidthFull ? {
          flex: 1
        } : {}
        let thisStyle = {
          width: this.options.titleWidthAuto !== true && this.options.titleWidthFull !== true ? (this.options.titleWidth || this.options.titleWidth) + "px" : "",
          ...widthFull,
          height: this.options.titleHeightAuto !== true ? this.options.titleHeight + "px" : "",
          "-webkit-line-clamp": this.options.titleTextLimitLines,
          "border-top-left-radius": isActive
            ? `${this.options.titleActiveBorderTopLeftRadius}px`
            : `${this.options.titleBorderTopLeftRadius}px`,
          "border-top-right-radius": isActive
            ? `${this.options.titleActiveBorderTopRightRadius}px`
            : `${this.options.titleBorderTopRightRadius}px`,
          "border-bottom-right-radius": isActive
            ? `${this.options.titleActiveBorderBottomRightRadius}px`
            : `${this.options.titleBorderBottomRightRadius}px`,
          "border-bottom-left-radius": isActive
            ? `${this.options.titleActiveBorderBottomLeftRadius}px`
            : `${this.options.titleBorderBottomLeftRadius}px`,
          "border-style": isActive ? this.options.titleActiveBorderStyle : this.options.titleBorderStyle,
          // "border-color": isActive
          //   ? this.options.titleActiveBorderIsThemeColor
          //     ? this.themeColor
          //     : this.options.titleActiveBorderColor.color || this.options.titleActiveBorderColor
          //   : this.options.titleBorderIsThemeColor
          //   ? this.themeColor
          //   : this.options.titleBorderColor.color || this.options.titleBorderColor,
          "border-color": isActive ? this.$parseColor(this.options.titleActiveBorderColor, {
            isThemeColor: this.options.titleActiveBorderIsThemeColor
          }) : this.$parseColor(this.options.titleBorderColor, {
            isThemeColor: this.options.titleBorderIsThemeColor
          }),
          "border-width": showBorder !== false ? borderW : 0,
          "box-shadow": this.titleBoxShadowStyle,
          padding: this.getTitlePaddingStyle,
          transform: "rotate(" + (this.options.titleRotate || 0) + "deg)"
        }
        return {
          ...this.titleFontStyle(isActive),
          ...this.titleBgStyle(isActive),
          ...thisStyle
        }
      }
    },
    titleFontStyle() {
      return function (isActive) {
        return {
          "font-Family": isActive ? this.options.titleActiveFontFamily : this.options.titleFontFamily,
          "font-size": isActive ? `${this.options.titleActiveFontSize}px` : `${this.options.titleFontSize}px`,
          "font-weight": isActive ? this.options.titleActiveFontWeight : this.options.titleFontWeight,
          "line-height": isActive
            ? `${this.options.titleActiveLineHeight}${this.options.titleActiveLineHeightType === "%" ? "%" : "px"}`
            : `${this.options.titleLineHeight}${this.options.titleLineHeightType === "%" ? "%" : "px"}`,
          "font-style": isActive ? this.options.titleActiveFontStyle : this.options.titleFontStyle,
          // "text-align": isActive ? this.options.titleActiveTextAlign : this.options.titleTextAlign,
          "writing-mode": isActive ? this.options.textActiveWritingMode : this.options.titleWritingMode,
          "letter-spacing": isActive
            ? `${this.options.titleActiveLetterSpacing}px`
            : `${this.options.titleLetterSpacing}px`,
          "text-decoration": isActive ? this.options.titleActiveTextDecoration : this.options.titleTextDecoration,
          "text-decoration-color": this.$parseColor(this.options.color),
          // color: isActive
          //   ? this.options.titleActiveTextIsThemeColor
          //     ? this.themeColor
          //     : this.options.titleActiveColor.color || this.options.titleActiveColor
          //   : this.options.titleTextIsThemeColor
          //   ? this.themeColor
          //   : this.options.titleColor.color,
          color: isActive ? this.$parseColor(this.options.titleActiveColor, {
            isThemeColor: this.options.titleActiveTextIsThemeColor
          }) : this.$parseColor(this.options.titleColor, {
            isThemeColor: this.options.titleTextIsThemeColor
          }),
          ...this.alignStyle(isActive ? this.options.titleActiveTextAlign : this.options.titleTextAlign)
        }
      }
    },
    // 产品要求，已选状态回显样式为选中样式
    getFontStyle() {
      return function(item) {
        let thisStyle = {}
        if (this.options.openSelectedStatus) {
          if (item.children?.length > 0) {
            const activeList = item.children.filter(item1 => item1.active && item1.label !== "全部")
            if (activeList.length) {
              thisStyle = this.titleFontStyle(true)
            }
          }
        }
        return thisStyle
      }
    },
    titleIconStyle() {
      return function (isActive) {
        return {
          display: "inline-block",
          // "--color": isActive
          //   ? this.options.titleActiveIconColorIsThemeColor
          //     ? this.themeColor
          //     : this.options.titleActiveIconColor.color || this.options.titleActiveIconColor
          //   : this.options.titleIconColorIsThemeColor
          //   ? this.themeColor
          //   : this.options.titleIconColor.color || this.options.titleIconColor,
          "--color": isActive ? this.$parseColor(this.options.titleActiveIconColor, {
            isThemeColor: this.options.titleActiveIconColorIsThemeColor
          }) : this.$parseColor(this.options.titleIconColor, {
            isThemeColor: this.options.titleIconColorIsThemeColor
          }),
          fontSize: isActive ? `${this.options.titleActiveIconWidth}px` : `${this.options.titleIconWidth}px`,
          width: isActive ? `${this.options.titleActiveIconWidth}px` : `${this.options.titleIconWidth}px`,
          height: isActive ? `${this.options.titleActiveIconWidth}px` : `${this.options.titleIconWidth}px`,
          margin: this.getMargin(isActive)
        }
      }
    },
    titleIconImgStyle() {
      return function (isActive) {
        return {
          width: isActive ? `${this.options.titleActiveIconWidth}px` : `${this.options.titleIconWidth}px`,
          margin: this.getMargin(isActive)
        }
      }
    },
    getMargin() {
      return function(isActive) {
        return isActive
          ? this.options.titleActiveIconPosition === "left"
          ? `0 ${this.options.titleActiveIconMargin}px 0 0`
          : `0 0 0 ${this.options.titleActiveIconMargin}px`
          : this.options.titleIconPosition === "left"
          ? `0 ${this.options.titleIconMargin}px 0 0`
          : `0 0 0 ${this.options.titleIconMargin}px`
      }
    },
    titleIconPosition() {
      return function (isActive) {
        return isActive ? this.options.titleActiveIconPosition : this.options.titleIconPosition
      }
    },
    titleIconType() {
      return function (isActive) {
        return isActive ? this.options.titleActiveIconType : this.options.titleIconType
      }
    },
    filterStyle() {
      const { filterAlignmentType, filterMargin, filterShowTabsScorll } = this.options
      return {
        justifyContent:
          filterAlignmentType === "left" || filterShowTabsScorll
            ? "flex-start"
            : filterAlignmentType === "right"
            ? "flex-end"
            : "center",
        gap: `${filterMargin}px`,
        flexWrap: filterShowTabsScorll ? "nowrap" : "wrap",
        overflowX: filterShowTabsScorll ? "auto" : "none",
        padding: this.getPaddingStyle
      }
    },
    subMenuHeightAuto () {
      return this.options.hasOwnProperty("subMenuHeightAuto") ? this.options.subMenuHeightAuto : true
    },
    subMenuHeightFull () {
      return this.options.hasOwnProperty("subMenuHeightFull") ? this.options.subMenuHeightFull : false
    },
    subMenuWidthAuto () {
      return this.options.hasOwnProperty("subMenuWidthAuto") ? this.options.subMenuWidthAuto : true
    },
    subMenuWidthFull () {
      return this.options.hasOwnProperty("subMenuWidthFull") ? this.options.subMenuWidthFull : false
    },
    filterType() {
      const extraConfig = this.options?.subMenuConfig?.find(item => item.menuId === this.activeValue)?.extraConfig || {}
      return extraConfig.hasOwnProperty("filterType") ? extraConfig.filterType : "1"
    },
    openResetButton() {
      return this.options.hasOwnProperty("openResetButton") ? this.options.openResetButton : true
    },
    dialogBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.subFilterDialogBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("subFilterDialogBgColorIsThemeColor") ? this.options.subFilterDialogBgColorIsThemeColor : false,
            color: "rgba(0,0,0,0.3)"
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor ? this.themeColor : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return {
        ...containerBg
      }
    },
    subBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.subFilterBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("subFilterBgColorIsThemeColor") ? this.options.subFilterBgColorIsThemeColor : false,
            color: "rgba(255,255,255,1)"
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor ? this.themeColor : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    subMenuBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.subFilterBoxShadowH)) {
        this.options.subFilterBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.subFilterBoxShadowH[index]}px ${_this.options.subFilterBoxShadowV[index]}px ${_this.options.subFilterBoxShadowBlur[index]}px ${_this.options.subFilterBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.subFilterBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.subFilterBoxShadowH || 0}px ${this.options.subFilterBoxShadowV || 0}px ${this.options.subFilterBoxShadowBlur || 0}px ${this.options.subFilterBoxShadowSpread || 0}px ${this.$parseColor(this.options.subFilterBoxShadowColor)}`
      }
      return tmpStyle
    },
    getSubMenuPaddingStyle() {
      let padding = `${this.options.subFilterPadding}px`
      if (!this.options.subFilterPadding || this.options.subFilterPaddingTypeFlag === 2) {
        padding = ` ${this.options.subFilterPaddingTop}px  ${this.options.subFilterPaddingRight}px  ${this.options.subFilterPaddingBottom}px  ${this.options.subFilterPaddingLeft}px`
      }
      return padding
    },
    subFilterStyle () {
      let borderW = ""
      if (Array.isArray(this.options.subFilterBorderWidth)) {
        this.options.subFilterBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.subFilterBorderWidth}px`
      }
      const row = this.options.hasOwnProperty("menuRowContent") ? this.options.menuRowContent : 3
      const gapNumber = this.options.columnMargin * (row - 1)
      const width = `calc((100% - ${gapNumber}px) / ${row})`
      let maxWidth = this.options.subFilterShowMaxWidth ? this.options.subFilterMaxWidthVal + "px" : ""
      let minWidth = this.options.subFilterShowMinWidth ? this.options.subFilterMinWidthVal + "px" : ""
      return {
        maxWidth: maxWidth,
        minWidth: minWidth,

        "--rowGap": this.options.lineMargin + "px",
        "--columnGap": this.options.columnMargin + "px",
        "--subMenuWidth": width,
        ...this.subBgStyle,
        "border-style": this.options.subFilterBorderStyle || parseInt(borderW) && "solid",
        // "border-color": this.options.subFilterBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.subFilterBorderColor?.color || this.options.subFilterBorderColor,
        "border-color": this.$parseColor(this.options.subFilterBorderColor, {
          isThemeColor: this.options.subFilterBorderIsThemeColor
        }),
        "border-width": this.options.subFilterShowBorder !== false ? borderW : 0,
        "border-top-left-radius": this.options.subFilterBorderTopLeftRadius + "px",
        "border-top-right-radius": this.options.subFilterBorderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.subFilterBorderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.subFilterBorderBottomLeftRadius + "px",
        "box-shadow": this.subMenuBoxShadowStyle,
        opacity: this.options.hasOwnProperty("subFilterOpacity") ? this.options.subFilterOpacity / 100 : 1,
        padding: this.getSubMenuPaddingStyle,
      }
    },
    subMenuBoxStyle () {
      let maxHeight = this.options.subFilterShowMaxHeight ? this.options.subFilterMaxHeightVal + "px" : ""
      let minHeight = this.options.subFilterShowMinHeight ? this.options.subFilterMinHeightVal + "px" : ""
      return {
        height: this.options.subFilterHeightAuto === false ? this.options.subFilterHeight + "px" : "",
        maxHeight: maxHeight,
        minHeight: minHeight,
      }
    },

    footerStyle() {
      return {
        "--footerHeight": this.options.hasOwnProperty("filterBottomHeight") ? this.options.filterBottomHeight + "px" : "50px",
        // ...this.subBgStyle,
      }
    },
    labelIconPosition() {
      return this.options.labelIconPosition || "right"
    },
    labelShow() {
      return this.options.hasOwnProperty("labelShow") ? this.options.labelShow : false
    },
    labelBoxBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.labelBoxBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("labelBoxBgColorIsThemeColor") ? this.options.labelBoxBgColorIsThemeColor : false,
            color: ""
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor ? this.themeColor : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    labelBoxBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.labelBoxBoxShadowH)) {
        this.options.labelBoxBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.labelBoxBoxShadowH[index]}px ${_this.options.labelBoxBoxShadowV[index]}px ${_this.options.labelBoxBoxShadowBlur[index]}px ${_this.options.labelBoxBoxShadowSpread[index]}px ${this.$parseColor(_this.options.labelBoxBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.labelBoxBoxShadowH || 0}px ${this.options.labelBoxBoxShadowV || 0}px ${this.options.labelBoxBoxShadowBlur || 0}px ${this.options.labelBoxBoxShadowSpread || 0}px ${this.$parseColor(this.options.labelBoxBoxShadowColor)}`
      }
      return tmpStyle
    },
    selectBoxStyle() {
      const { labelAlignmentType, labelLineMargin, labelColumnMargin, showLabelScorll } = this.options
      let padding = `${this.options.labelBoxPadding}px`
      if (!this.options.labelBoxPaddingTypeFlag || this.options.labelBoxPaddingTypeFlag === 2) {
        padding = ` ${this.options.labelBoxPaddingTop || 0}px ${this.options.labelBoxPaddingRight || 0}px ${this.options.labelBoxPaddingBottom || 0}px ${this.options.labelBoxPaddingLeft || 0}px`
      }
      let borderW = ""
      if (Array.isArray(this.options.labelBoxBorderWidth)) {
        this.options.labelBoxBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.labelBoxBorderWidth}px`
      }
      return {
        ...this.labelBoxBgStyle,
        height: this.options.labelBoxHeightAuto === false ? this.options.labelBoxHeight + "px" : "",
        opacity: this.options.hasOwnProperty("labelBoxOpacity") ? this.options.labelBoxOpacity / 100 : 1,
        justifyContent:
          labelAlignmentType === "left" || showLabelScorll || !labelAlignmentType
            ? "flex-start"
            : labelAlignmentType === "right"
            ? "flex-end"
            : "center",
        columnGap: labelColumnMargin !== undefined ? labelColumnMargin + "px": 10 + "px",
        rowGap: labelLineMargin !== undefined ? labelLineMargin + "px" : 10 + "px",
        flexWrap: showLabelScorll ? "nowrap" : "wrap",
        overflowX: showLabelScorll ? "auto" : "none",
        padding: padding,
        "border-style": this.options.labelBoxBorderStyle || (parseInt(borderW) && "solid"),
        // "border-color": this.options.labelBoxBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.labelBoxBorderColor?.color || this.options.labelBoxBorderColor,
        "border-color": this.$parseColor(this.options.labelBoxBorderColor, {
          isThemeColor: this.options.labelBoxBorderIsThemeColor
        }),
        "border-width": this.options.labelBoxShowBorder !== false ? borderW : 0,
        "border-top-left-radius": this.options.labelBoxBorderTopLeftRadius + "px",
        "border-top-right-radius": this.options.labelBoxBorderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.labelBoxBorderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.labelBoxBorderBottomLeftRadius + "px",
        "box-shadow": this.labelBoxBoxShadowStyle,
      }
    },
    labelBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.labelBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("labelBgColorIsThemeColor") ? this.options.labelBgColorIsThemeColor : false,
            color: ""
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor ? this.themeColor : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    labelBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.labelBoxShadowH)) {
        this.options.labelBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.labelBoxShadowH[index]}px ${_this.options.labelBoxShadowV[index]}px ${_this.options.labelBoxShadowBlur[index]}px ${_this.options.labelBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.labelBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.labelBoxShadowH || 0}px ${this.options.labelBoxShadowV || 0}px ${this.options.labelBoxShadowBlur || 0}px ${this.options.labelBoxShadowSpread || 0}px ${this.$parseColor(this.options.labelBoxShadowColor)}`
      }
      return tmpStyle
    },
    selectStyle() {
      let padding = `${this.options.labelPadding}px`
      if (!this.options.labelPaddingTypeFlag || this.options.labelPaddingTypeFlag === 2) {
        padding = ` ${this.options.labelPaddingTop}px ${this.options.labelPaddingRight}px ${this.options.labelPaddingBottom}px ${this.options.labelPaddingLeft}px`
      }
      let borderW = ""
      if (Array.isArray(this.options.labelBorderWidth)) {
        this.options.labelBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.labelBorderWidth}px`
      }
      return {
        ...this.labelBgStyle,
        width: this.options.labelWidthAuto === false ? this.options.labelWidth + "px" : "",
        height: this.options.labelHeightAuto === false ? this.options.labelHeight + "px" : "",
        opacity: this.options.hasOwnProperty("labelOpacity") ? this.options.labelOpacity / 100 : 1,
        "font-Family": this.options.labelFontFamily,
        "font-size": this.options.hasOwnProperty("labelFontSize") ? `${this.options.labelFontSize}px` : "16px",
        "font-weight": this.options.labelFontWeight,
        "line-height": this.options.hasOwnProperty("labelLineHeight") ? `${this.options.labelLineHeight}${this.options.labelLineHeightType === "%" ? "%" : "px"}` : "24px",
        "font-style": this.options.labelFontStyle,
        "text-align": this.options.labelTextAlign,
        "writing-mode": this.options.labelWritingMode,
        "letter-spacing": `${this.options.labelLetterSpacing}px`,
        "text-decoration": this.options.labelTextDecoration,
        "text-decoration-color": this.$parseColor(this.options.labelColor),
        // color: this.options.labelTextIsThemeColor
        //   ? this.themeColor
        //   : this.options.labelColor?.color,
        color: this.$parseColor(this.options.labelColor, {
          isThemeColor: this.options.labelTextIsThemeColor
        }),
        padding: padding,
        "border-style": this.options.labelBorderStyle || (parseInt(borderW) && "solid"),
        // "border-color": this.options.labelBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.labelBorderColor?.color || this.options.labelBorderColor,
        "border-color": this.$parseColor(this.options.labelBorderColor, {
          isThemeColor: this.options.labelBorderIsThemeColor
        }),
        "border-width": this.options.labelShowBorder !== false ? borderW : 0,
        "border-top-left-radius": this.options.labelBorderTopLeftRadius + "px",
        "border-top-right-radius": this.options.labelBorderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.labelBorderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.labelBorderBottomLeftRadius + "px",
        "box-shadow": this.labelBoxShadowStyle,
      }
    },
    getShowIcon() {
      return function(isActive) {
        return isActive ? this.options.showActiveIcon : this.options.showDefaultIcon
      }
    },
    subMenuIconPosition() {
      return function(isActive) {
        return isActive ? this.options.activeIconPosition || "left" : this.options.defaultIconPosition || "left"
      }
    },
    subMenuIconType() {
      return function(isActive) {
        return isActive ? this.options.activeIconType || "icon" : this.options.defaultIconType || "icon"
      }
    },
    subMenuIconStyle() {
      return function(isActive) {
        return {
          display: "inline-block",
          // "--color": isActive
          //   ? this.options.activeIconColorIsThemeColor
          //     ? this.themeColor
          //     : this.options.activeIconColor?.color || this.options.activeIconColor
          //   : this.options.defaultIconColorIsThemeColor
          //   ? this.themeColor
          //   : this.options.defaultIconColor?.color || this.options.defaultIconColor,
          "--color": isActive ? this.$parseColor(this.options.activeIconColor, {
            isThemeColor: this.options.activeIconColorIsThemeColor
          }) : this.$parseColor(this.options.defaultIconColor, {
            isThemeColor: this.options.defaultIconColorIsThemeColor
          }),
          fontSize: isActive ? `${this.options.activeIconWidth}px` : `${this.options.defaultIconWidth}px`,
          width: isActive ? `${this.options.activeIconWidth}px` : `${this.options.defaultIconWidth}px`,
          height: isActive ? `${this.options.activeIconWidth}px` : `${this.options.defaultIconWidth}px`,
          margin: this.getSubMenuMargin(isActive)
        }
      }
    },
    subMenuIconImgStyle() {
      return function (isActive) {
        return {
          width: isActive ? `${this.options.activeIconWidth}px` : `${this.options.defaultIconWidth}px`,
          margin: this.getSubMenuMargin(isActive)
        }
      }
    },
    getSubMenuMargin() {
      return function (isActive) {
        const iconPosition = isActive ? this.options.activeIconPosition : this.options.defaultIconPosition
        const iconMargin = isActive ? this.options.activeIconMargin : this.options.defaultIconMargin
        return iconPosition === "right"
          ? `0 0 0 ${iconMargin}px`
          : iconPosition === "left"
          ? `0 ${iconMargin}px 0 0`
          : iconPosition === "top"
          ? `0 0 ${iconMargin}px 0`
          : iconPosition === "bottom"
          ? `${iconMargin}px 0 0 0`
          : "0 0 0 0"
      }
    },
    labelIconStyle() {
      return {
        display: "inline-block",
        // "--color": this.options.labelconColorIsThemeColor
        //   ? this.themeColor
        //   : this.options.labelIconColor?.color || this.options.labelIconColor,
        "--color": this.$parseColor(this.options.labelIconColor, {
          isThemeColor: this.options.labelconColorIsThemeColor
        }),
        fontSize: `${this.options.labelIconWidth}px`,
        width: `${this.options.labelIconWidth}px`,
        height: `${this.options.labelIconWidth}px`,
        margin: this.getLabelMargin
      }
    },
    labelIconImgStyle() {
      return {
        width: `${this.options.labelIconWidth}px`,
        margin: this.getLabelMargin
      }
    },
    getLabelMargin() {
      const iconPosition = this.labelIconPosition
      const iconMargin = this.options.labelIconMargin
      return iconPosition === "right"
        ? `0 0 0 ${iconMargin}px`
        : iconPosition === "left"
        ? `0 ${iconMargin}px 0 0`
        : iconPosition === "top"
        ? `0 0 ${iconMargin}px 0`
        : iconPosition === "bottom"
        ? `${iconMargin}px 0 0 0`
        : "0 0 0 0"
    },
    showToggleButton() {
      return this.options.hasOwnProperty("buttonShow") ? this.options.buttonShow : false
    },
  },
  mounted() {
    console.log("this.options", this.options)
    if (this.options.restDataUrl) {
      if(this.options.pluginName?.includes("controlMulitiFilter")) {
        let triggerParams = getQueryParam("triggerParams")
        if(triggerParams) {
          triggerParams = JSON.parse(decodeURIComponent(triggerParams))
        }
        this.updateData(triggerParams || null)
      } else {
        this.updateData()
      }
    }
    this.selectOptionsNew = this.options.selectOptions
    if (this.options.indrawer) {
      window.localStorage.setItem("multiSelectOptions", JSON.stringify(this.options.selectOptions))
    }
    this.$initPlugin(this.options?.pluginName)
    if (this.model === "tree") {
      this.initMultiFilterTree()
    }
    if (this.model === "filter") {
      this.$nextTick(()=> {
        this.initFilterPositions()
      })
      const self = this
      this.$eventBus.$on('openSelectedSubMenu', data => {
        const { rect_id, publicId } = data
        if (self?.myid?.rect_id === rect_id) {
          const menuIndex = self.selectOptionsNew.findIndex(item => item.publicId === publicId)
          if (menuIndex !== undefined && menuIndex !== null) {
            self.filterFunc(false, menuIndex, 3)
          }
        }
      })
    }

    //初始化展开收起按钮
    if(!this.model && this.moreFilter === true){
      this.toggleDataFunc1(this.selectOptionsNew)
    }else if(this.model === "tree"){
      this.toggleDataFunc1(this.selectedOptions)
    }

    if(this.options.pluginName?.includes("triggerMulitiFilter")) {
      let triggerParams = getQueryParam("triggerParams")
      if(triggerParams) {
        triggerParams = JSON.parse(decodeURIComponent(triggerParams))
        this.handleItemClick({ id: triggerParams.id, level: 0 })
      }
    }
    if(this.options.pluginName?.includes("controlMulitiFilter")) {
      this.$eventBus.$on("trigger-mulitiFilter-change", this.handleMulitiControl)
    }
  },
  beforeDestroy() {
    this.$eventBus.$off("trigger-mulitiFilter-change", this.handleMulitiControl)
  },
  methods: {
    alignStyle(textAlign) {
      let alignStyleObj = {}
      let alignItems = "center"
      switch (textAlign) {
        case "left":
          alignItems = "flex-start"
          break
        case "center":
          alignItems = "center"
          break
        case "right":
          alignItems = "flex-end"
          break
        default:
      }

      if (this.model === 'filter') {
        alignStyleObj = {
          justifyContent: alignItems,
        }
      } else {
        alignStyleObj = {
          textAlign: textAlign
        }
      }
      return alignStyleObj
    },
    getTitleContent(item) {
      let lable = item.label
      if (this.options.openSelectedStatus) {//开启已选状态,把选中项回显
        if (item.children?.length > 0) {
          const activeList = item.children.filter(item1 => item1.active && item1.label !== "全部")
          if (activeList.length) {
            lable = activeList.map(item1 => item1.label).join(',') || label
          }
        }
      }
      let newLabel = this.titleContentHasLimit ? lable.substr(0, this.options.titleTextLimitCount) : label
      return newLabel
    },
    getSelectedItems() {
      const selectedItems = []
      this.selectedOptions.forEach((val, index) => {
        const targetItem = (this.displayItems[index] || []).find(a => a.id == val)
        targetItem && selectedItems.push(targetItem)
      })
      return selectedItems
    },
    initMultiFilterTree() {
      this.filterItems = []
      this.filterItems = this.flatTree(this.options.filterOptions, this.filterItems, 0, "")
      // 需要检查一下当前的已选择数据是否还存在于filterItmes中
      const filterItemIds = this.filterItems.map(item => item.id)
      if (this.options.selectOptions?.length) {
        this.selectedOptions = this.options.selectOptions.map(item => item.id || item.publicId)
      } else {
        this.selectedOptions = this.filterItems.length ? (this.showAll ? [""] : [this.filterItems[0].id]) : []
      }
      this.selectedOptions.some((val, index) => {
        if (val && filterItemIds.indexOf(val) === -1) {
          // 说明上一次选择的筛选项已经没在当次可筛选条目中了, 直接干掉, 同时如果当前级别还有其他值，则将选择项定位
          // 为当前级别的第一个或者全部
          const restItems = this.filterItems.filter(item => item.parentId === (this.selectedOptions[index - 1] || ""))
          if (restItems.length) {
            this.selectedOptions.splice(index, 100, this.showAll ? "" : restItems[0].id)
            this.options.selectOptions.splice(
              index,
              100,
              this.showAll
                ? {
                    id: "",
                    level: index,
                    parentId: this.selectedOptions[index - 1] || "",
                    label: "全部"
                  }
                : restItems[0]
            )
          } else {
            this.selectedOptions.splice(index, 100)
            // 这个时候store里面可能存的还是原有的数据，也删了
            this.options.selectOptions.splice(index, 100)
          }
        }
      })
      this.initDisplayItems(this.selectedOptions)
      let clickItem = null
      if (this.options.selectOptions?.length) {
        clickItem = this.options.selectOptions.slice(-1)[0]
      } else {
        if (this.filterItems.length) {
          if (this.showAll) {
            clickItem = {
              label: "全部",
              level: 0,
              parentId: "",
              id: ""
            }
          } else {
            clickItem = this.filterItems[0]
          }
        }
      }
      clickItem && this.handleItemClick(clickItem)
    },
    initDisplayItems(values) {
      values.forEach((val, index) => {
        const items = this.filterItems.filter(
          item => item.level === index && item.parentId === (values[index - 1] || "")
        )
        if (val === "" && !this.showAll) {
          // 如果已经选了全部，但是又取消勾选了 显示""全部分类", 将已选的值回退至第一个
          this.selectedOptions.splice(index, 1, items[0].id)
        }
        if (items.length) {
          this.displayItems.splice(
            index,
            1,
            this.showAll
              ? [{ id: "", label: "全部", parentId: values[index - 1] || "", level: index }, ...items]
              : items
          )
        }
      })
    },
    // 将树形数据扁平化
    flatTree(data = [], target, level = 0, parentId) {
      data.forEach(item => {
        target &&
          target.push({
            ...item,
            id: item.id,
            parentId,
            level,
            label: item.label
          })
        if (item.children && item.children.length) {
          this.flatTree(item.children, target, level + 1, item.id)
        }
      })
      return target
    },
    // 点击某一项
    handleItemClick(item, manual) {
      const { id, level } = item
      this.selectedOptions.splice(level, 1, id)
      if (id === "") {
        // 如果id为''代表选的是当前层级的全部，这个时候要关闭当前层级的以下层级
        this.selectedOptions.splice(level + 1, 100)
      } else {
        // 说明选中的是某一个具体项，则需要情况后续展开下一层级并默认选中第一个
        const nextLevelDatas = this.filterItems
          .filter(i => i.parentId === id && i.level === level + 1)
          .sort(j => j.number)
        if (nextLevelDatas.length) {
          const insertedItems = this.showAll
            ? [{ label: "全部", id: "", level: level + 1, parentId: "id" }, ...nextLevelDatas]
            : nextLevelDatas
          this.displayItems.splice(level + 1, 1, insertedItems)
          this.handleItemClick(insertedItems[0])
        } else {
          this.selectedOptions.splice(level + 1, 100)
          this.displayItems.splice(level + 1, 100)
        }
      }
      const tmpData = JSON.parse(JSON.stringify(this.getSelectedItems()))
      if (!this.options.indrawer) {
        this.$store.dispatch(this.request_prefix + "/changeOptions", {
          ...this.myid,
          option_name: "selectOptions",
          option_val: tmpData
        })
        this.selectOptionsNew = tmpData
      } else {
        this.selectOptionsNew = tmpData
        window.localStorage.setItem("multiTreeSelectOptions", JSON.stringify(tmpData))
      }
      this.dispatchListPageRefreshData(tmpData)
      //  重新计算是否显示展开收起按钮
      this.toggleDataFunc1(this.selectedOptions)
      this.handleMulitiTrigger(tmpData, manual)
    },
    /**
     * 绑定了多级筛选插件触发
     */
    handleMulitiTrigger(tmpData, manual) {
      if(this.options.pluginName?.includes("triggerMulitiFilter") && manual) {
        const notEmptyData = tmpData.filter(item => item.id)
        let result = []
        let cur = result
        for(let i = 0; i < notEmptyData.length; i++) {
          if(notEmptyData[i].id) {
            let data = {
              id: notEmptyData[i].id,
              name: notEmptyData[i].label
            }
            if(i < notEmptyData.length - 1) {
              data.subs = []
            }
            cur.push(data)
            cur = data.subs
          }
        }
        this.$eventBus.$emit("trigger-mulitiFilter-change", result)
      }
    },
    /**
     * 监听多级筛选插件触发
     */
    handleMulitiControl(filterClassify) {
      this.updateData(filterClassify.length ? filterClassify : null)
    },
    activeFunc(isActive, index2, type, index1) {
      if (isActive && isActive !== undefined) {
        return
      }
      let tmpData = JSON.parse(JSON.stringify(this.selectOptionsNew))
      if (type === 1) {
        //样式1
        tmpData[index1].children.forEach(function (item) {
          item.active = false
        })
        tmpData[index1].children[index2].active = true
      } else {
        //样式2
        tmpData.forEach(function (item) {
          item.active = false
        })
        tmpData[index2].active = true
      }
      console.log("activeFunc", isActive, index2, type, index1, tmpData)
      if (!this.options.indrawer) {
        this.$store.dispatch(this.request_prefix + "/changeOptions", {
          ...this.myid,
          option_name: "selectOptions",
          option_val: tmpData
        })
        this.selectOptionsNew = tmpData
      } else {
        this.selectOptionsNew = tmpData
        window.localStorage.setItem("multiSelectOptions", JSON.stringify(tmpData))
      }
      this.dispatchListPageRefreshData(tmpData)
    },
    filterFunc(isActive, index2, type, index1) {
      console.log("filterFunc", isActive, index2, type, index1)
      let tmpData = JSON.parse(JSON.stringify(this.selectOptionsNew))
      const _this = this
      if (type === 3) {// 样式4 一级分类
        this.showDialog = !isActive
        if (!isActive) {
          this.activeValue = tmpData[index2].publicId
          //取消所有选中项，选中当前一级菜单
          tmpData.forEach(function (item, index) {
            item.active = false
            if (index2 === index && _this.filterType !==  "2" && item.children?.length) {// 单选
              const isAll = item.children.every(item => !item.active)
              // 选中全选
              isAll ? item.children[0].active = true : ""
            }
          })
        }
        tmpData[index2].active = this.showDialog
        this.subMenuList = tmpData[index2].children
        this.activeIndex = index2
        if (!this.subMenuList) return
        this.initFilterPositions()
      } else if (type === 4) {// 样式4 二级分类
        if (this.filterType === "1") {
          this.showDialog = false
          tmpData[index1].children.forEach(function (item, index) {
            index !== index2 ? item.active = false : ""
          })
        }
        tmpData[index1].children[index2].active = !tmpData[index1].children[index2].active
        this.subMenuList = tmpData[index1].children
      }
      this.selectOptionsNew = tmpData
      if (type === 4 && this.filterType !== "2") {// 只有二级分类的单选会修改数据
        this.$store.dispatch(this.request_prefix + "/changeOptions", {
          ...this.myid,
          option_name: "selectOptions",
          option_val: tmpData
        })
        tmpData[index1].active = false
      }
      this.dispatchListPageRefreshData(tmpData)
    },
    async updateData(filterClassify) {
      const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
      const appId = this.options.appId
      if (!appId) {
        return
      }
      const { restDataUrl, restUrl } = await getAppointCacheData.call(
        this,
        pageId,
        wfwfid,
        websiteId,
        appId,
        { filterClassify }
      )
      this.$changeOptionsEV(restDataUrl, "restDataUrl", false, false, false, true)
      let datas,
        targetData = []
      this.setMyFetchParam(appId) // 设置请求参数
      if (restUrl.data.code === 1) {
        datas = restUrl.data.data.generalDataTypes
        this.doObj(datas, targetData)
        if (this.options.moreFilter) {
          let allList = {
            active: true,
            children: [],
            label: "全部",
            publicId: "",
            relId: ""
          }
          targetData.forEach((item, index) => {
            item.children.unshift(allList)
          })
        }
        this.$changeOptionsEV(
          targetData,
          this.options.model === "tree" ? "filterOptions" : "selectOptions",
          false,
          null,
          this.myid,
          true
        )
        if (this.options.moreFilter) {
          this.options.selectOptions.forEach((item, index) => {
            if (item.children.length > 0) {
              item.children[0].active = true
            }
          })
        } else {
          if (this.options.selectOptions.length > 0) {
            targetData[0].active = true
          }
        }
      }
    },
    doObj(datas, targetData) {
      for (let key in datas) {
        targetData.push({
          id: datas[key].publicId,
          label: datas[key].name,
          value: datas[key].url,
          iconUrl: datas[key].iconUrl,
          publicId: datas[key].publicId,
          relId: datas[key].relId,
          children: [],
          cid: datas[key].id,
          pid: datas[key].pid,
        })
        if (typeof datas[key].subGeneralDataTypes == "object") {
          this.doObj(datas[key].subGeneralDataTypes, targetData[key].children)
        }
      }
    },
    setMyFetchParam(appId) {
      const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
      this.$changeOptionsEV(
        {
          pageId: pageId,
          wfwfid,
          websiteId,
          appId
        },
        "myFetchParam",
        false,
        null,
        {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id
        },
        true
      )
    },
    closeDrawer() {
      this.selectOptionsNew = this.options.selectOptions
      this.drawerShow.drawer = false
    },
    confirmDrawer() {
      let selectOptions1 = JSON.parse(window.localStorage.getItem("multiSelectOptions"))
      this.$store.dispatch(this.request_prefix + "/changeOptions", {
        ...this.myid,
        option_name: "selectOptions",
        option_val: selectOptions1
      })
      this.drawerShow.drawer = false
    },
    getParentNode(e, res = [], cls) {
      const parentNode = e.parentNode
      if (parentNode) {
        let elClasslist = parentNode.classList
        if ([].find.call(elClasslist, it => it === "edit_stage")) {
          return []
        } else if ([].find.call(elClasslist, it => it === cls)) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getParentNode(parentNode, res, cls)
        }
      } else {
        return res
      }
    },
    initFilterPositions() {
      const filterLayer = this.$refs.filterLayer
      const pageLayout = filterLayer ? this.getParentNode(filterLayer,[], "page-layout-wrapper")[0]?.getBoundingClientRect() : undefined
      const client = filterLayer ? filterLayer.getBoundingClientRect() : undefined
      const el = document.querySelector(".filterRect .option-layer")
      if (client) {
        el.style.top = client.top + client.height + "px"
        el.style.left = pageLayout.left + "px"
        el.style.width = pageLayout.width + "px"
      }
    },
    resetData() {
      let tmpData = JSON.parse(JSON.stringify(this.selectOptionsNew))
      tmpData.forEach(function (item) {// 清空当前所有二级菜单选中项
        if (item.active) {
          item.children.forEach(function (subItem) {
            subItem.active = false
          })
        }
      })
      this.subMenuList = tmpData[this.activeIndex]?.children
      this.selectOptionsNew = tmpData
      this.$store.dispatch(this.request_prefix + "/changeOptions", {
        ...this.myid,
        option_name: "selectOptions",
        option_val: tmpData
      })
    },
    confirmData() {
      this.selectOptionsNew[this.activeIndex].active = false
      this.$store.dispatch(this.request_prefix + "/changeOptions", {
        ...this.myid,
        option_name: "selectOptions",
        option_val: this.selectOptionsNew
      })
      this.showDialog = false
    },
    delClick(item, index) {
      this.selectList.splice(index, 1)
      let tmpData = JSON.parse(JSON.stringify(this.selectOptionsNew))
      // 删除当前标签，当前标签不一定是展开项subMenuList里的，所以需要遍历所有的
      tmpData.forEach((item1, index1) => {
        item1.children.forEach((subItem, subIndex) => {
          if (subItem.publicId === item.publicId) {
            subItem.active = false
            return
          }
        })
      })
      this.subMenuList = tmpData[this.activeIndex].children
      this.selectOptionsNew = tmpData
      this.$store.dispatch(this.request_prefix + "/changeOptions", {
        ...this.myid,
        option_name: "selectOptions",
        option_val: tmpData
      })
    },
    getSelectList(tmpData) {
      let list = []
      tmpData.forEach(item=>{
        if (item.active) this.activeValue = item.publicId
        item.children.forEach(function (subItem, index) {
          if (subItem.label !== "全部" && subItem.active) {
            list.push(subItem)
          }
        })
      })
      this.selectList = list
    },
    getSubMenuConfig(option) {
      let subMenuConfig
      if (this?.options?.subMenuConfig?.length) {
        subMenuConfig = this.options.subMenuConfig.find(item => item.menuId === option.publicId)?.extraConfig
      }
      return subMenuConfig || {}
    },
    /**
     * 通过列表页插件初始化多级筛选数据
     * @param {*} restUrl 分类数据
     */
    initListPageMultiFilterData(plugin) {
      let targetData = []
      const stage = this.$store.state[this.request_prefix]
      const rectAttr = getAttrById(stage, this.myid)
      this.doObj(plugin.restUrl.data.data.generalDataTypes, targetData)
      //获取选中样式
      let ifMore = rectAttr.options.moreFilter
      let model = rectAttr.options.model
      let isFilter = model === "filter"
      if (model !== "tree" && ifMore) {
        // 杜磊需求，如果自由布局开了显示全部分类，那么在列表页的多级筛选样式1中，不显示全部那一行
        targetData = targetData.filter(item => !(item.label === '全部' && !item.publicId))
      }
      if (ifMore || isFilter) {
        let allList = {
          active: true,
          children: [],
          label: "全部",
          publicId: "",
          relId: ""
        }
        targetData.forEach((item, index) => {
          let list = JSON.parse(JSON.stringify(allList))
          // 当前菜单的筛选方式
          const filterType = this.getSubMenuConfig(item)?.filterType
          if (isFilter && filterType !== "2") {
            list.publicId = item.publicId
            list.relId = item.relId
          }
          if (isFilter && filterType === "2" ) return
          item.children.unshift(list)
        })
      } else {
        if (targetData.length > 0) {
          //多级筛选样式2和3，支持从首页跳转时携带1级分类信息并且反选中
          let activeIndex = 0
          if(plugin.typeId){
            targetData.forEach((item1, index1)=>{
              if(item1.publicId === plugin.typeId){
                activeIndex = index1
              }
            })
          }
          if(this.options.styleId === 2){
            targetData[activeIndex].active = true

          }else if(this.options.styleId === 3){
            this.handleItemClick(this.filterItems[activeIndex])
          }
          else{
            targetData[0].active = true
          }
        }
      }
      this.$changeOptionsEV(
        targetData,
        model === "tree" ? "filterOptions" : "selectOptions",
        false,
        null,
        this.myid,
        true
      )
      this.$changeOptionsEV(this.appId, "appId", false, null, this.myid, true)
    },
    /**
     * 通过列表页插件初始化多级筛选数据新版
     * @param {*} plugin 插件实例
     */
    initSubPageMultiFilterData(plugin) {
      let targetData = []
      const stage = this.$store.state[this.request_prefix]
      const rectAttr = getAttrById(stage, this.myid)
      this.doObj(plugin.restUrl.data.data.generalDataTypes, targetData)
      //获取选中样式
      let ifMore = rectAttr.options.moreFilter
      let model = rectAttr.options.model
      let isFilter = model === "filter"
      if (model !== "tree" && ifMore) {
        // 杜磊需求，如果自由布局开了显示全部分类，那么在列表页的多级筛选样式1中，不显示全部那一行
        targetData = targetData.filter(item => !(item.label === '全部' && !item.publicId))
      }
      if (ifMore || isFilter) {
        let allList = {
          active: true,
          children: [],
          label: "全部",
          publicId: "",
          relId: ""
        }
        targetData.forEach((item, index) => {
          let list = JSON.parse(JSON.stringify(allList))
          // 当前菜单的筛选方式
          const filterType = this.getSubMenuConfig(item)?.filterType
          if (isFilter && filterType !== "2") {
            list.publicId = item.publicId
            list.relId = item.relId
          }
          if (isFilter && filterType === "2" ) return
          item.children.unshift(list)
        })
      } else {
        if (targetData.length > 0) {
          //多级筛选样式2和3，支持从首页跳转时携带1级分类信息并且反选中
          let activeIndex = 0
          if(plugin.typeId){
            targetData.forEach((item1, index1)=>{
              if(item1.publicId === plugin.typeId){
                activeIndex = index1
              }
            })
          }
          if(this.options.styleId === 2){
            targetData[activeIndex].active = true

          }else if(this.options.styleId === 3){
            this.handleItemClick(this.filterItems[activeIndex])
          }
          else{
            targetData[0].active = true
          }
        }
      }
      this.$changeOptionsEV(
        targetData,
        model === "tree" ? "filterOptions" : "selectOptions",
        false,
        null,
        this.myid,
        true
      )
      this.$changeOptionsEV(this.appId, "appId", false, null, this.myid, true)
    },
    // 触发列表页数据刷新
    dispatchListPageRefreshData(selectOptions) {
      let typeId = "",
          typeIdsArr = [],
          relIdsArr = [],
          isOr = false,
          groupTypeId = {}
      if (selectOptions.length) {
        relIdsArr = []
        if (this.options.model === "tree") {
          selectOptions = [...selectOptions].reverse().filter(item => item.id)
          ;(typeIdsArr = [selectOptions[0]?.publicId || ""]), (relIdsArr = [selectOptions[0]?.relId || ""])
        } else if (this.options.model === "filter") {
          let subTypeIdsArr = []
          let subRelIdsArr = []
          let flag = false
          selectOptions.forEach(item => {
            if (item.active) {
              typeIdsArr.push(item.publicId)
              relIdsArr.push(item.relId)
            }
            if (item.children.length) {
              item.children.forEach(item1 => {
                if (item1.active && item1.label !== "全部") {
                  flag = true
                  subTypeIdsArr.push(item1.publicId)
                  subRelIdsArr.push(item1.relId)
                  // 后端说pid等于0时不传
                  item1.pid !== "0" ? groupTypeId[item1.pid] ? groupTypeId[item1.pid] = groupTypeId[item1.pid] + ',' + item1.cid : groupTypeId[item1.pid] = item1.cid : groupTypeId = ""
                }
              })
            }
          })
          if (flag) {
            typeIdsArr = subTypeIdsArr
            relIdsArr = subRelIdsArr
            if (subTypeIdsArr.length > 1) {// 多个分类
              isOr = true
            }
          }
        } else {
          let flag = false
          selectOptions.forEach(item => {
            if (item.active) {
              typeIdsArr.push(item.publicId)
              relIdsArr.push(item.relId)
            }
            if (item.children.length) {
              item.children.forEach(item1 => {
                if (item1.active && item1.label !== "全部") {
                  flag = true
                  typeIdsArr.push(item1.publicId)
                  relIdsArr.push(item1.relId)
                  // 一帆让加上groupTypeId 多级筛选选择多个时取交集
                  // 后端说pid等于0时不传
                  item1.pid !== "0" ? groupTypeId[item1.pid] ? groupTypeId[item1.pid] = groupTypeId[item1.pid] + ',' + item1.cid : groupTypeId[item1.pid] = item1.cid : groupTypeId = ""
                }
              })
            }
          })
          if (flag && typeIdsArr.length > 1) {// 多个分类
            isOr = true
          }
        }
      }
      if (!this.options.moreFilter && typeIdsArr?.length > 0) {
        typeId = typeIdsArr[0]
      }
      if (this.$subPageEvent.contexts) {
        let types = []
        Object.keys(this.$subPageEvent.contexts).forEach(key => {
          // if (key.indexOf("cxDataGrid") !== -1) {
          //   types.push("cxDataGrid")
          // }
          // if (key.indexOf("cxBreadCrumbs") !== -1) {
          //   types.push("cxBreadCrumbs")
          // }
          // if (key.indexOf("cxNoteEditor") !== -1) {
          //   types.push("cxNoteEditor")
          // }
          if (key.indexOf("cxDataGrid") !== -1 || key.indexOf("cxBreadCrumbs") !== -1 || key.indexOf("cxNoteEditor") !== -1) {
            types.push(key)
          }
        })
        if (types.length > 0) {
          this.$eventBus.$emit("subPage-component-init", {
            type: types,
            typeId: typeId,
            typeIds: typeIdsArr,
            relIds: relIdsArr,
            isOr: isOr,
            groupTypeId: isOr ? groupTypeId : ""
          })
        }
      }
    },
    //循环计算按钮显示
    toggleDataFunc1(val, isClear){
      this.countNumber++
      if(this.options.toggleButton && this.showToggleButton && val.length > 0 || isClear){
        if($(".filter-layer1").length === val.length){
          for(let i=0;i<val.length;i++){
            this.toggleData(false, i, isClear)
          }
        }else if(this.countNumber < 8){
          //最多执行7次
          setTimeout(()=>{
            this.toggleDataFunc1(val, isClear)
          }, 100)
        }
        if(!this.isBigScreenPreview()){
          //展开收起按钮   开关切换
          if($(".toggleButton").length < 1){
            setTimeout(()=>{
              this.toggleDataFunc1(val)
            }, 500)
          }
        }
      }
    },
    //判断是否需要显示展开收起按钮
    toggleData(isClick, index, isClear){
      //获取dom判断有几行
      let idStr = this.ids.rect_id + "_" + index
      let dom1 = document.getElementById(idStr)
      if(!dom1) return
      if(isClear){
        $(dom1).removeClass("btn-computed")
        $(dom1).removeClass("hideMoreLine")
        dom1.style.height = "auto"
        return
      }
      let domHeight = $(dom1)[0].offsetHeight
      //一级分类高度
      let titleHeight = $(dom1).find(".layer1-name")[0].offsetHeight
      let titleHeight0 = this.options.titleHeightAuto ? this.options.titleLineHeight : this.options.titleHeight
      if(titleHeight0 && titleHeight < titleHeight0){
        titleHeight = titleHeight0
      }
      //子分类高度
      let subMenuHeight = $(dom1).find(".filter-layer2")[0].offsetHeight
      //子分类行间距
      let columnMargin = this.options.lineMargin
      let btnId ="btn_" + this.ids.rect_id + '_' + index
      let ifTitleHigh = true, height1 = titleHeight
      if(titleHeight < (columnMargin + subMenuHeight)){
        height1 = columnMargin + subMenuHeight
        ifTitleHigh = false
      }
      if(!$(dom1).hasClass("btn-computed")){
        if(!document.getElementById(btnId)){
          return
        }
        //第一次计算
        $(dom1).addClass("btn-computed")
        if(domHeight > height1 + 10){
          document.getElementById(btnId).style.display = "block"
          //  隐藏第二行
          $(dom1).addClass("hideMoreLine")
          dom1.style.height = height1 + "px"
        }else {
          document.getElementById(btnId).style.display = "none"
        }
      }else if(isClick){
        //  展开收起按钮点击
        if($(dom1).hasClass("hideMoreLine")){
          $(dom1).removeClass("hideMoreLine")
          dom1.style.height = "auto"
        }else{
          $(dom1).addClass("hideMoreLine")
          dom1.style.height = height1 + "px"
        }
      }
    },
  }
}
</script>

<style scoped lang="scss">
.vertical-layer {
  flex-wrap: wrap;
  .layer2-box {
    flex-basis: 100%;
    flex-shrink: 0;
  }
}
.multiFilter-component ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
.multiFilter-component {
  position: relative;
  height: 100%;
  width: 100%;
}
.multiFilter-component ::v-deep .el-scrollbar__view {
  height: 100%;
}
.multiFilter-component .filter-box .layer1-name {
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.multiFilter-component .filter-box .filter-layer2:hover {
  font-family: var(--hoverFontFamily) !important;
  font-size: var(--hoverFontSize) !important;
  font-weight: var(--hoverFontWeight) !important;
  line-height: var(--hoverLineHeight) !important;
  font-style: var(--hoverFontStyle) !important;
  letter-spacing: var(--hoverLetterSpacing) !important;
  text-decoration: var(--hoverTextDecoration) !important;
  text-decoration-color: var(--hoverTextDecorationColor) !important;
  color: var(--hoverColor) !important;
  border-top-left-radius: var(--hoverBorderTopLeftRadius) !important;
  border-top-right-radius: var(--hoverBorderTopRightRadius) !important;
  border-bottom-right-radius: var(--hoverBorderBottomRightRadius) !important;
  border-bottom-left-radius: var(--hoverBorderBottomLeftRadius) !important;
  border-style: var(--hoverBorderStyle) !important;
  border-color: var(--hoverBorderColor) !important;
  border-width: var(--hoverBorderWidth) !important;
  box-shadow: var(--hoverBoxShadow) !important;
  background-color: var(--hoverBackgroundColor) !important;
  background-image: var(--hoverBackgroundImage) !important;
  background-size: var(--hoverBackgroundSize) !important;
  background-position: var(--hoverBackgroundPosition) !important;
  background-repeat: var(--hoverBackgroundRepeat) !important;
}
.multiFilter-component .filter-box .filter-layer2.active-type,
.option-layer .sub-menu.active-type {
  font-family: var(--activeFontFamily) !important;
  font-size: var(--activeFontSize) !important;
  font-weight: var(--activeFontWeight) !important;
  line-height: var(--activeLineHeight) !important;
  font-style: var(--activeFontStyle) !important;
  letter-spacing: var(--activeLetterSpacing) !important;
  text-decoration: var(--activeTextDecoration) !important;
  text-decoration-color: var(--activeTextDecorationColor) !important;
  color: var(--activeColor) !important;
  border-top-left-radius: var(--activeBorderTopLeftRadius) !important;
  border-top-right-radius: var(--activeBorderTopRightRadius) !important;
  border-bottom-right-radius: var(--activeBorderBottomRightRadius) !important;
  border-bottom-left-radius: var(--activeBorderBottomLeftRadius) !important;
  border-style: var(--activeBorderStyle) !important;
  border-color: var(--activeBorderColor) !important;
  border-width: var(--activeBorderWidth) !important;
  box-shadow: var(--activeBoxShadow) !important;
  background-color: var(--activeBackgroundColor) !important;
  background-image: var(--activeBackgroundImage) !important;
  background-size: var(--activeBackgroundSize) !important;
  background-position: var(--activeBackgroundPosition) !important;
  background-repeat: var(--activeBackgroundRepeat) !important;
}

.multiFilter-component.has-drawer .filter-box {
  margin-bottom: 56px;
  padding-top: 20px;
}
.multiFilter-component .demo-drawer__footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #eeeeee;
  display: flex;
}
.multiFilter-component .demo-drawer__footer .el-button {
  width: 50%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 56px;
  padding: 0;
  border: 0 !important;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  font-weight: 600;
  font-size: 20px;
}
.multiFilter-component .demo-drawer__footer .el-button--default {
  color: #999999;
}
.multiFilter-component .demo-drawer__footer .el-button--primary {
  color: var(--themeColor);
  background-color: white !important;
}
.multiFilter-component .filter-box .filter-layer1:last-child {
  margin-bottom: 0 !important;
}
.multiFilter-component .filter-box .filter-layer1:last-child .layer2-box {
  margin-bottom: var(--layer2MarginBottom) !important;
}
.filter-layer, .filter-query {
  display: flex;
  position: relative;
  &::-webkit-scrollbar {
    width: 8px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
  .filter-item {
    flex-shrink: 0;
    cursor: pointer;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }
}
.filter-layer .filter-item {
  display: flex;
  align-items: center;
}
.option-layer {
  position: absolute;
  z-index: 999;
  width: 400px;
  bottom: 0;
  .sub-box {
    background: white;
    width: 100%;
    .menu-div {
      overflow-y: auto;
    }
    .menu-box {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: flex-start;
      column-gap: var(--columnGap);
      row-gap: var(--rowGap);
      .sub-menu {
        width: var(--subMenuWidth);
        cursor: pointer;
      }
    }
  }
  .filter-footer {
    height: var(--footerHeight);
    position: relative;
    .btn {
      position: absolute;
    }
  }
}
.inline {
  display: inline-block;
  line-height: 1;
}
  .hideMoreLine{
    overflow: hidden;
  }
</style>
